import { SelectItem } from "@components/Common/Select/types"

const selectGerenciadora: SelectItem[] = [
    { label: 'OpentecH', value: 'OPENTECH' },
    { label: 'EM', value: 'EM' },
    { label: 'Outros', value: 'OUTROS' },
]

export default selectGerenciadora